/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Image {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { graphql } from "gatsby"
import { Image as ImageModule } from "@bw/modules"

const Image = ({
  suptitle,
  title,
  subtitle,
  legend,
  displaySize,
  desktopImage,
  mobileImage,
}) => {
  console.log(displaySize)
  return (
    <Section
      suptitle={suptitle}
      title={title}
      subtitle={subtitle}
      fullWidth={displaySize === "large"}
    >
      <ImageModule
        legend={legend}
        imageUrl={desktopImage.url}
        alt={desktopImage.alt}
        display={displaySize}
      />
    </Section>
  )
}

export default Image

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on ImageModule {
 *   ...ImageModuleFragment
 * }
 *
 * This is also what you will get in the props of your Image
 * resolver component.
 */
export const query = graphql`
  fragment ImageModuleFragment on ImageModule {
    legend
    displaySize
    mobileImage {
      url
      alt
    }
    desktopImage {
      url
      alt
    }
  }
`
